import styles from "./loadingDots.module.css";

export const LoadingDots = ({ className }) => {
  return (
    <div className={className || styles.loadingContainer}>
      <div className={styles.loadingDots}>
        <div className={`${styles.dot} ${styles.dot1}`}></div>
        <div className={`${styles.dot} ${styles.dot2}`}></div>
        <div className={`${styles.dot} ${styles.dot3}`}></div>
        <div className={`${styles.dot} ${styles.dot4}`}></div>
      </div>
    </div>
  );
};
